import { CircleDollarSign } from "lucide-react";
import { FC } from "react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { GasInfoByNetwork, getGasDescription } from "@/lib/chains";
import { cn } from "@/lib/utils";

type Props = {
  chainId: keyof typeof GasInfoByNetwork;
  currentGas: number;
  gasLow: boolean;
};

export const GasPriceAlert: FC<Props> = ({ chainId, currentGas, gasLow }) => (
  <Alert
    variant={gasLow ? "default" : "destructive"}
    className={cn("mt-6", gasLow && "text-green-600")}
  >
    <CircleDollarSign className="size-4" />
    <AlertTitle className="text-base">
      {currentGas.toFixed(GasInfoByNetwork[chainId].decimals)}{" "}
      {GasInfoByNetwork[chainId].unit}
    </AlertTitle>
    <AlertDescription className="text-sm">
      {getGasDescription(chainId, gasLow)}
    </AlertDescription>
  </Alert>
);
